export default __webpack_public_path__ + "static/media/arrow right.a8d06d8a.svg";